import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WiderTable } from '@/components';
import { useQueryGiftVipHistoryList, useGiftVipChangeFollowState } from '../hooks';
import { wrapModalPromise } from '@/utils/modal';
import { useCurrentUserId } from '@/utils';
import { getGiftHistoryColumns } from './columns';
import style from './index.module.css';
import { SendVipBtn } from '@/components/SendVipBtn';

type Props = {
  hide(): void;
  userId: string;
};

export const GiftVipHistoryModal = ({ hide, userId }: Props) => {
  const { t } = useTranslation();
  const { data, isLoading, refetch } = useQueryGiftVipHistoryList(userId);
  const currentUserId = useCurrentUserId();
  const handleFollowChange = useGiftVipChangeFollowState();

  const userMarkColumns = useMemo(
    () => getGiftHistoryColumns(handleFollowChange, hide, currentUserId),
    [currentUserId, handleFollowChange, hide],
  );
  const vipListCount = useMemo(() => data?.vip_list.length || 0, [data?.vip_list.length]);
  return (
    <div>
      <div className={style.header}>
        <div className={style.title}>
          {t('GiftVipHistoryModal.title')}{' '}
          <span className={style.sub}>{vipListCount ? `(${vipListCount})` : ''}</span>
        </div>
        <SendVipBtn />
      </div>
      <WiderTable
        className={style.table}
        loading={isLoading}
        columns={userMarkColumns}
        reload={refetch}
        data={data?.vip_list || []}
        bodyHeight={200}
      />
    </div>
  );
};

export const openGiftVipHistoryModal = wrapModalPromise<{ userId: string }>(GiftVipHistoryModal, {
  containerClassName: style.modalContainer,
});
